/**
 * PushEnApp — recibe del service worker los avisos push que llegan con la app abierta y a la vista:
 * suena el tono del tipo de aviso (si la preferencia es «con sonido»), vibra y muestra un toast que lleva a lo que pasó.
 * No dibuja nada propio.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "./Toast.jsx";
import { sonarAviso } from "../lib/sonidos.js";

export default function PushEnApp() {
  const { toast } = useToast();
  const navigate = useNavigate();
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const alRecibir = (e) => {
      if (e.data?.type !== "PUSH_RECIBIDO") return;
      const a = e.data.aviso || {};
      if (a.sonido === "sonido") sonarAviso(a.categoria);
      if (a.sonido !== "silencio" && Array.isArray(a.vibrate) && a.vibrate.length && navigator.vibrate) { try { navigator.vibrate(a.vibrate); } catch { /* sin vibración */ } }
      toast.info(a.title || "Aviso nuevo", {
        description: a.body || undefined,
        action: a.url ? { label: "Abrir", onClick: () => navigate(a.url) } : undefined,
      });
    };
    navigator.serviceWorker.addEventListener("message", alRecibir);
    return () => navigator.serviceWorker.removeEventListener("message", alRecibir);
  }, [toast, navigate]);
  return null;
}
